import { render, staticRenderFns } from "./Developer.vue?vue&type=template&id=39634595&"
import script from "./Developer.vue?vue&type=script&lang=js&"
export * from "./Developer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports